<div class="filter-container">
  <div class="button-container">
    <div class="button-container-buttons desktop-actions">
      <button mat-button="outlined" (click)="openColumnManager()" [attr.aria-label]="'Kolumninställningar'">
        <fa-icon [icon]="iconService.getIcon('columnChanger')"></fa-icon>
        Kolumner
      </button>
      <button mat-button="outlined" class="export-button" mat-raised-button matTooltip="Exportera"
        (click)="exportToExcel()">Exportera
        <mat-icon>file_download</mat-icon>
      </button>
    </div>

    <div class="mobile-actions">
      <button mat-button class="actions-toggle" [matMenuTriggerFor]="contractorActionsMenu" aria-label="Visa åtgärder">
        Kolumner/Exportera
      </button>
    </div>
  </div>

  <mat-menu #contractorActionsMenu="matMenu">
    <button mat-menu-item (click)="openColumnManager()">
      <fa-icon class="menu-icon" [icon]="iconService.getIcon('columnChanger')"></fa-icon>
      <span>Kolumner</span>
    </button>
    <button mat-menu-item (click)="exportToExcel()">
      <mat-icon class="menu-icon">file_download</mat-icon>
      <span>Exportera</span>
    </button>
  </mat-menu>

  <app-contractor-list-filter></app-contractor-list-filter>

</div>
<section class="table-container mat-elevation-z8">
  <table id="contractor-list" mat-table [dataSource]="isLoading ? skeletonRows : contractorDataSource"
    class="mat-elevation-z8 contractor-table" matSort>
    @for (column of combinedColumns; track $index) {
    <ng-container [matColumnDef]="column.columnDef" [sticky]="column.columnDef === 'organisationNumber'">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{ 'text-align-right': column.align === 'right' }"
        [ngStyle]="{ 
            minWidth: column.minWidth ? column.minWidth + 'px' : 'auto',
            textAlign: column.align || 'left'
          }">
        <mat-icon class="header-icon">{{column.icon}}</mat-icon>
        {{column.header}}
      </th>
      <td mat-cell *matCellDef="let row" [ngStyle]="{ textAlign: column.align || 'left' }">
        @if(isLoading) {
        <div class="skeleton-line"></div>
        }
        @if (!isLoading) {
        @if (column.route) {
        <a class="regular-link" [routerLink]="column.route(row)">
          {{column.cell(row)}}
        </a>
        }

        @if (!column.route) {
        <span [innerHTML]="getCellValue(column.cell(row))">
        </span>
        }
        }

      </td>
    </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</section>
<mat-paginator [pageSizeOptions]="[20, 30, 50, contractorDataSource.data.length]" showFirstLastButtons></mat-paginator>